import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import EsimActions from '../../Redux/EsimRedux'

class EsimCountry extends React.Component {
  constructor (props) {
    super(props)

    let countries = []
    props.country_list.map((item, i) => {
      countries[i] = {
        value: item.id,
        label: item.name
      }
      return countries
    })

    let detailCountry = []
    props.detail.countries.forEach((country) => {
      detailCountry.push({value: country.id, label: country.name})
    })

    this.countries = countries
    this.state = {
      selectedCountry: [ ...detailCountry ],
    }
  }

  _selectChange = (selectedCountry) => {
    this.setState({ selectedCountry })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {
      countries: []
    }

    this.state.selectedCountry.forEach(country => {
      form.countries.push(country.value)
    })

    this.props.submit({id: this.props.detail.id, form})
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '50vw', minHeight: '30vh' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Country List
          </h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-10'>
              <Select
                isMulti
                options={this.countries}
                value={this.state.selectedCountry}
                onChange={(selectedCountry) => this._selectChange(selectedCountry)}
                placeholder='Select country to assign ...'
              />
            </div>
            <div className='col-2'>
              <button type='submit' className='btn btn-primary'>Assign</button>
            </div>
          </div>
        </form>
        <div className='row'>
          <div className='col-12 text-right'>
            <button onClick={() => this.props.closeModal()} className='btn btn-secondary mr-2'>Close</button>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  country_list: state.preset.dataCountries,
})

const dispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(EsimActions.esimUpdateCountryRequest(data))
})

export default connect(stateToProps, dispatchToProps)(EsimCountry)



// WEBPACK FOOTER //
// ./src/Containers/Esim/EsimCountry.js